import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import useSocket from "../../common/useSocket";
import {sendData} from "../../../store/actions";
import Layout from "../../../components/layout/Layout";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";

const InviteClient = () => {
    const history = useHistory();
    const {token} = useParams();

    const [inviteClientData, setInviteClientData] = useState({});
    const [error, setError] = useState(null);

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'acceptClientInvitation':
                    setInviteClientData(res?.data)
                    break;
                default:
                    return true;
            }
        } else {
            setError(res?.data)
        }
    })

    useEffect(() => {
        if (token?.length === 36) sendData('', 'acceptClientInvitation', {token})
        else history.push('/login')
        refresh();
        return () => off();
    },[])

    return (
        <React.Fragment>
            <Layout module="">
                <div className="u_account-form">
                    <Commonrightcircle/>
                    {!error ? <div className="u_confirm-account">
                            <img src="../images/images/confirm-account.png" alt="confirm-account" className="u_m-auto"/>
                            <div className="u_confirm-account-header">
                                <h2 className="u_text-center u_py-20">Your account is confirmed.</h2>
                                <p className="u_mt-10">Here is the Email and Password you will need to log in! Keep it a secret!</p>
                            </div>
                            <div className="u_flex u_content-center u_my-10">
                                <div className="u_confirm-account-content">
                                    <p className="u_pb-10">Email : <strong>{inviteClientData?.email ?? ''}</strong></p>
                                    <p>Password : <strong>{inviteClientData?.password ?? ''}</strong></p>
                                </div>
                            </div>
                            <button type="button" className="u_account-btn u_w-full u_cp" onClick={e => history.push('/login')}>Let’s Sign In</button>
                        </div>
                        :
                        <div className="u_confirm-account">
                            <img src="../images/images/something-wrong.png" alt="something-wrong" className="u_m-auto"/>
                            <div className="u_confirm-account-header">
                                <h2 className="u_text-center u_py-20">Something went wrong</h2>
                                {error?.error && <span>{error?.error}</span>}
                            </div>
                            {error?.showButton && <button type="button" className="u_account-btn u_w-full u_cp u_mt-10" onClick={e => history.push('/login')}>Let’s Sign In</button>}
                        </div>
                    }
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default InviteClient;
